import React from "react";

import { EImagingModuleStatus } from "../../Model/ModuleState";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleState } from "./../../redux/reducers/ModuleStateReducer";

import OverviewStatus, { EOverviewModuleStatus } from "./OverviewStatus";

import { EModuleType } from "../../Model/EModuleType";
import { Module } from "../../Model/Module";

type ImagerStatusProps = {
  module: Module;
};

function getImagingModuleState(state: EImagingModuleStatus) {
  switch (state) {
    case EImagingModuleStatus.Diagnosing:
    case EImagingModuleStatus.Ejecting:
    case EImagingModuleStatus.Homing:
    case EImagingModuleStatus.Imaging:
    case EImagingModuleStatus.Retracting:
    case EImagingModuleStatus.Starting:
    case EImagingModuleStatus.Stopping:
      return EOverviewModuleStatus.Busy;
    case EImagingModuleStatus.Faulted:
      return EOverviewModuleStatus.Error;
    default:
      return EOverviewModuleStatus.Idle;
  }
}

export default function ImagerStatus(props: ImagerStatusProps) {
  const { module } = props;
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, module.identifier)
  );
  const imagerState = moduleState.imager;
  if (imagerState == null) throw new Error("Imager state is null");

  const statusText = imagerState.status;
  const plateText = imagerState.plate ? imagerState.plate.barcode : "Empty";
  let statusses: { [index: string]: React.ReactNode } = {
    Status: statusText,
    Plate: plateText,
  };

  const moduleStatus = getImagingModuleState(imagerState.state);

  return (
    <OverviewStatus
      moduleType={EModuleType.IMAGER}
      name={`IMAGER - ${module.name}`}
      statusses={statusses}
      moduleStatus={moduleStatus}
    />
  );
}
